if (!customElements.get('specs-slider')) {
    class SpecsSlider extends HTMLElement {
        connectedCallback() {
            this.triggers = this.querySelectorAll('.slide-trigger')
            this.slides = this.querySelectorAll('.specs-slide')

            this.popup = this.querySelector(
                `.data-popup-container-${this.dataset.sectionId}`
            )

            this.carousel = this.popup?.querySelector('custom-carousel')
            this.closeBtns = this.popup?.querySelectorAll('.popup-close-btn')

            this.setupSlides()

            if (window.innerWidth >= 1024) {
                this.activateSlide(1)
            }
        }

        setupSlides() {
            this.triggers.forEach(trigger => {
                const index = Number(trigger.dataset.slideIndex) - 1

                trigger.addEventListener('mouseenter', () => {
                    if (window.innerWidth >= 1024) {
                        this.activateSlide(index + 1)
                    }
                })

                trigger.addEventListener('click', () => {
                    this.activateSlide(index + 1)

                    if (window.innerWidth < 1024) {
                        this.openMobile(index)
                    }
                })
            })

            this.closeBtns?.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.closeMobile()
                })
            })
        }

        activateSlide(index) {
            const activeIndex = String(index)

            this.slides.forEach(slide => {
                slide.classList.toggle(
                    'active-slide',
                    slide.dataset.slideIndex === activeIndex
                )
            })

            this.triggers.forEach(trigger => {
                trigger.classList.toggle(
                    'active-slide',
                    trigger.dataset.slideIndex === activeIndex
                )
            })

            // this.pauseAllVideos()
        }

        openMobile(slideIndex) {
            if (this.carousel && this.carousel.embla) {
                setTimeout(() => {
                    this.carousel.embla.scrollTo(slideIndex)
                }, 50)
            }

            this.popup.classList.add('active-popup')
            document.body.classList.add('overflow-hidden')
        }

        closeMobile() {
            this.popup.classList.remove('active-popup')
            document.body.classList.remove('overflow-hidden')
            // this.pauseAllVideos()
        }

        pauseAllVideos() {
            this.querySelectorAll('video')?.forEach(video => {
                if (!video.paused) {
                    video.pause()
                    video.currentTime = 0
                }
            })
        }
    }

    customElements.define('specs-slider', SpecsSlider)
}